import {useEffect, useRef, memo} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {canUseDOM} from 'Utils';

const propTypes = {
    children: PropTypes.node.isRequired,
    node: PropTypes.any
};

const Portal = (props) => {
    const defaultNode = useRef(null);

    if (!canUseDOM) {
        return null;
    }

    useEffect(() => {
        return () => {
            if (defaultNode.current) {
                document.body.removeChild(defaultNode.current);
            }
            defaultNode.current = null;
        }
    }, []);

    if (!props.node && !defaultNode.current) {
        defaultNode.current = document.createElement('div');
        document.body.appendChild(defaultNode.current);
    }
    
    return ReactDOM.createPortal(
        props.children,
        props.node || defaultNode.current
    );
};

Portal.propTypes = propTypes;

export default memo(Portal);